
import { Link } from "react-router-dom";
import { CaseStudyCard } from "../advisory/CaseStudyCard";
import { caseStudies } from "@/data/caseStudyData";

export const SuccessStoriesSection = () => {
  // Filter for case studies relevant to managed services
  const managedServicesCaseStudies = caseStudies.filter(study => 
    study.id === "legal-firm-practice-management" || 
    study.id === "financial-services-business-continuity" || 
    study.id === "tech-company-infrastructure-scaling"
  );

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50" id="success-stories">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="space-y-12">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tight text-edgefi-black sm:text-4xl">
              Success Stories From Businesses Like Yours
            </h2>
            <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
              See how we've transformed IT operations for organizations across industries
            </p>
          </div>
          
          <div className="grid grid-cols-1 gap-10">
            {managedServicesCaseStudies.map((study, index) => (
              <CaseStudyCard
                key={index}
                id={study.id}
                title={study.title}
                industry={study.industry}
                companyType={study.companyType}
                challenge={study.challenge}
                solution={study.solution}
                results={study.results}
                testimonial={study.testimonial}
                cta={study.cta}
                tags={study.tags}
                redactedName={study.redactedName}
              />
            ))}
          </div>
          
          <div className="text-center mt-8">
            <Link 
              to="/case-studies" 
              className="inline-flex items-center gap-2 text-edgefi-purple hover:text-purple-800 font-medium"
            >
              View all case studies
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                className="transition-transform group-hover:translate-x-1"
              >
                <path d="M5 12h14"></path>
                <path d="m12 5 7 7-7 7"></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

// This is needed for lazy loading
export default SuccessStoriesSection;

